/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  PutApiMacroprojectsIdMutationRequest,
  PutApiMacroprojectsIdMutationResponse,
  PutApiMacroprojectsIdPathParams,
} from '../models/PutApiMacroprojectsId.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import {
  putApiMacroprojectsIdMutationResponseSchema,
  putApiMacroprojectsIdMutationRequestSchema,
} from '../zod/putApiMacroprojectsIdSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const putApiMacroprojectsIdMutationKey = () =>
  [{ url: '/api/macroProjects/:id' }] as const;

export type PutApiMacroprojectsIdMutationKey = ReturnType<
  typeof putApiMacroprojectsIdMutationKey
>;

/**
 * {@link /api/macroProjects/:id}
 */
export async function putApiMacroprojectsId(
  id: PutApiMacroprojectsIdPathParams['id'],
  data: PutApiMacroprojectsIdMutationRequest,
  config: Partial<RequestConfig<PutApiMacroprojectsIdMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = putApiMacroprojectsIdMutationRequestSchema.parse(data);
  const res = await request<
    PutApiMacroprojectsIdMutationResponse,
    ResponseErrorConfig<Error>,
    PutApiMacroprojectsIdMutationRequest
  >({
    method: 'PUT',
    url: `/api/macroProjects/${id}`,
    data: requestData,
    ...requestConfig,
  });
  return putApiMacroprojectsIdMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/macroProjects/:id}
 */
export function usePutApiMacroprojectsId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiMacroprojectsIdMutationResponse,
      ResponseErrorConfig<Error>,
      {
        id: PutApiMacroprojectsIdPathParams['id'];
        data: PutApiMacroprojectsIdMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PutApiMacroprojectsIdMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiMacroprojectsIdMutationKey();

  return useMutation<
    PutApiMacroprojectsIdMutationResponse,
    ResponseErrorConfig<Error>,
    {
      id: PutApiMacroprojectsIdPathParams['id'];
      data: PutApiMacroprojectsIdMutationRequest;
    },
    TContext
  >(
    {
      mutationFn: async ({ id, data }) => {
        return putApiMacroprojectsId(id, data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
